import * as Immutable from 'seamless-immutable';
import {
  ACTIVE_TEMPLATES_FETCH_API_FULFILLED,
  ACTIVE_TEMPLATES_FETCH_API_REJECTED,
  ACTIVE_TEMPLATES_SET_RECENTLY_USED,
  ACTIVE_TEMPLATES_FETCH_START
} from './templates-actions';

const activeTemplatesInitialState = Immutable.from({
  orderedIds: [],
  entitiesMap: {},
  pending: false,
  error: null,
  recentlyUsed: []
});

export default (state = activeTemplatesInitialState, action) => {
  switch (action.type) {
    case ACTIVE_TEMPLATES_FETCH_START:
      return state.merge({
        pending: true,
        error: null,
        orderedIds: [],
        entitiesMap: {}
      });
    case ACTIVE_TEMPLATES_FETCH_API_FULFILLED: {
      if (state.pending) {
        const {results} = action.payload;
        const {orderedIds, entitiesMap} = results.reduce(
          (acc, template) => ({
            orderedIds: acc.orderedIds.concat([template.id]),
            entitiesMap: acc.entitiesMap.set(template.id, template)
          }),
          state
        );
        return state.merge({
          entitiesMap,
          orderedIds,
          pending: false
        });
      }
      return state;
    }
    case ACTIVE_TEMPLATES_FETCH_API_REJECTED: {
      if (state.pending) {
        return state.merge({
          pending: false,
          error: action.payload
        });
      }
      return state;
    }
    case ACTIVE_TEMPLATES_SET_RECENTLY_USED:
      return state.set('recentlyUsed', action.payload);
    default:
      return state;
  }
};
